import { Wayfinding, WayfindingCardArticle, formatDateWithoutTimeZone, splitArticlePerParagraphs } from '@cbhq/cdx-components';
import { getComposeEntryProps } from '../../globals/composePage.js';
import { mapEntryLink } from '../../globals/navlink.js';
import { jsx } from 'react/jsx-runtime';
function ListingWayfinding({
  articles,
  fallbackImageUrl,
  fallbackImageAlt
}) {
  return /*#__PURE__*/jsx(Wayfinding, {
    columns: 1,
    rows: "all",
    compact: true,
    children: articles?.filter(entry => entry?.fields.content?.fields.headline).map((entry, index) => {
      const _getComposeEntryProps = getComposeEntryProps(entry),
        headline = _getComposeEntryProps.headline,
        image = _getComposeEntryProps.image,
        readTime = _getComposeEntryProps.readTime,
        composeSlug = _getComposeEntryProps.composeSlug,
        tags = _getComposeEntryProps.tags,
        excerpt = _getComposeEntryProps.excerpt,
        publicationDate = _getComposeEntryProps.publicationDate,
        articleBody = _getComposeEntryProps.articleBody;
      const firstSentence = articleBody && getFirstSentenceOfArticle(articleBody);
      const _ref = tags?.[0].fields || {},
        tagLabel = _ref.label,
        link = _ref.link;
      const tagLink = mapEntryLink(link);
      return /*#__PURE__*/jsx(WayfindingCardArticle, {
        mediaAlt: image?.fields?.title || fallbackImageAlt,
        mediaUrl: image?.fields?.file?.url || fallbackImageUrl,
        headline: headline || '',
        href: composeSlug,
        body: excerpt || firstSentence,
        datePublished: formatDateWithoutTimeZone(publicationDate),
        readTime: readTime,
        tagLabel: tagLabel,
        tagHref: tagLink.url && `/${tagLink.url}`,
        maxLines: 2
      }, index);
    })
  });
}
const firstSentenceRegex = /^(.*?)[.?!]\s/;
const getFirstSentenceOfArticle = article => {
  const articleParagraphs = splitArticlePerParagraphs(article);
  const articleParagraph = articleParagraphs[0].content.map(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  paragraph => paragraph.content.map(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  data => {
    if (data.value) return data.value;
    if (data.content) return data.content[0]?.value;
  }));
  const firstSentence = articleParagraph.flat().join(' ').match(firstSentenceRegex);
  return firstSentence && firstSentence[0] || '';
};
export { ListingWayfinding, getFirstSentenceOfArticle };
//# sourceMappingURL=ListingWayfinding.js.map
